import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { NumericUpDownCPanelComponent } from './customizationPanel';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';

export interface NumericUpDownCustomization {
  defaultValue: number;
  minValue?: number;
  maxValue?: number;
  step?: number;
  autocompleteRule: boolean;
}

@Component({
  selector: 'lib-numericupdown-edit',
  imports: [FormsModule, InputNumberModule, NumericUpDownCPanelComponent],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-numericupdown-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div class="p-fluid flex w-full flex-row">
          <p-inputNumber
            [autofocus]="false"
            id="data"
            [ngModel]="widget.customization.defaultValue"
            class="w-full rounded-md bg-white opacity-60"
            #number
            [disabled]="true"
            decrementButtonClass="bg-accent"
            incrementButtonClass="bg-accent"
          />
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class NumericUpDownComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<NumericUpDownCustomization>);
}
